<template>
    <div>
        <form-row title="Ability to extend Feasibility Period?" :no_border="true" class="mt-6">
            <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
                <input-radio-boolean
                    name="feasibility_can_extend"
                    v-model="feasibility_can_extend"
                    true="Yes"
                    false="No"
                    :read_only="read_only"
                    @input="updateCanExtend"
                />

                <div v-if="feasibility_can_extend" class="mt-4 sm:mt-0 pl-8 flex flex-1 items-center">
                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="feasibility_extend_days"
                            v-model="feasibility_extend_days"
                            placeholder="Days"
                            :read_only="read_only"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug px-4">
                        {{ $t('days, to') }}
                    </span>

                    <input-date
                        name="feasibility_extended_date"
                        :value="feasibility_extended_date"
                        :read_only="true"
                    />
                </div>
            </div>
        </form-row>

        <div v-if="feasibility_can_extend">
            <div class="border-b border-gray-400 mt-6"></div>

            <feasibility-period-extend-dates
                :commercial="commercial"
                :read_only="read_only"
            />

            <feasibility-period-extend-additional-money
                v-model="feasibility_additional_money_amount"
                :read_only="read_only"
            />

            <feasibility-period-extend-toward-purchase
                :commercial="commercial"
                :additional_money_amount="feasibility_additional_money_amount"
                :read_only="read_only"
            />

            <feasibility-period-extend-refundable
                :commercial="commercial"
                :additional_money_amount="feasibility_additional_money_amount"
                :read_only="read_only"
            />
        </div>
    </div>
</template>

<script>
import DateFunctions from '../../../../mixins/date-functions.js';
import FeasibilityPeriodExtendDates from './feasibility-period-extend-dates.vue';
import FeasibilityPeriodExtendAdditionalMoney from './feasibility-period-extend-additional-money.vue';
import FeasibilityPeriodExtendTowardPurchase from './feasibility-period-extend-toward-purchase.vue';
import FeasibilityPeriodExtendRefundable from './feasibility-period-extend-refundable.vue';

export default {
    mixins: [
        DateFunctions,
    ],

    components: {
        FeasibilityPeriodExtendDates,
        FeasibilityPeriodExtendAdditionalMoney,
        FeasibilityPeriodExtendTowardPurchase,
        FeasibilityPeriodExtendRefundable,
    },

    props: {
        commercial: {},
        feasibility_date: {},
        value: {},
        read_only: { default: false },
    },

    data() {
        return {
            feasibility_can_extend: this.commercial.feasibility_can_extend,
            feasibility_additional_money_amount: this.commercial.feasibility_additional_money_amount,
        }
    },

    computed: {
        feasibility_extend_days: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        feasibility_extended_date() {
            if (this.isValidDate(this.feasibility_date) && this.feasibility_extend_days) {
                return dayjs(this.feasibility_date.slice(0, 10))
                    .add({ day: this.feasibility_extend_days })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        updateCanExtend() {
            if (! this.feasibility_can_extend) {
                this.feasibility_extend_days = null;
            }
        },
    },
}
</script>
